import {SelectResize} from '../select-resize';

const strateOffresEmplois = {
    
    init() {
        const strates = document.querySelectorAll('.strate-offres-emplois');
        
        if (strates) {
            const selectElements = document.querySelectorAll('.strate-offres-emplois .js-categories-select');
            const allWrapperOffre = document.querySelectorAll('.strate-offres-emplois .wrapper_offre');
            const allWrapperSection = document.querySelectorAll('.strate-offres-emplois .wrapper_sections_oe');
            const wrapperSectionError = document.querySelector('.strate-offres-emplois .wrapper_section_error');

            selectElements.forEach((select) => {
                select.addEventListener('change', (event) => {
                    const this_taxo = select.getAttribute('name');
                    const this_value = select.options[select.selectedIndex].value;
                    // console.log(this_taxo);
                    // console.log(this_value);

                    allWrapperOffre.forEach((wrapperOffre) => {
                        wrapperOffre.classList.add('hidden');
                        wrapperOffre.classList.remove('show');
                    });

                    let allWrapperOffreVisible = allWrapperOffre;

                    if( this_value !== 'all') {
                        allWrapperOffreVisible = document.querySelectorAll('[data-' + this_taxo + '="' + this_value + '"]');
                    }

                    // montre les offres et liste les sections visibles
                    let sectionsVisible = [];

                    allWrapperOffreVisible.forEach((wrapperOffreVisible) => {
                        wrapperOffreVisible.classList.remove('hidden');
                        wrapperOffreVisible.classList.add('show');

                        sectionsVisible.push( wrapperOffreVisible.getAttribute('data-secteurs_offre_emploi') );
                    });

                    // reset other select
                    selectElements.forEach((otherSelect) => {
                        if( otherSelect.getAttribute('name') !== this_taxo ) {
                            // console.log( otherSelect.getAttribute('data-title') );
                            otherSelect.selectedIndex = 0;
                            new SelectResize(otherSelect);
                        }
                    });


                    // gestion des wrapper_sections_oe
                    const offresParsecteur = sectionsVisible.reduce((acc, curr) => {
                        if (typeof acc[curr] == 'undefined') {
                            acc[curr] = 1;
                        } else {
                            acc[curr] += 1;
                        }

                        return acc;
                    }, {});

                    allWrapperSection.forEach((wrapperSection) => {
                        wrapperSection.classList.add('hidden');
                    });

                    // comptage des items par section
                    for (var i in offresParsecteur) {
                        // console.log(i + ' ' + offresParsecteur[i]); // sales-et-operations 4
                        document.querySelector('.wrapper_sections_oe.' + i ).classList.remove('hidden');
                        document.querySelector('.wrapper_sections_oe.' + i + ' .inner_content_compteur' ).innerText = offresParsecteur[i];
                    }

                    // affichage message d'erreur
                    // console.log(sectionsVisible);
                    if( sectionsVisible.length > 0 ) {
                        wrapperSectionError.classList.add('hidden');
                    } else {
                        wrapperSectionError.classList.remove('hidden');
                    }


                });
            });

        }
    },
};

export default strateOffresEmplois;
